import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Box, Tooltip as MUITooltip, Paper, useTheme } from '@mui/material';
import { Caption, Subheader3 } from '../Typography';
const Tooltip = ({ title, placement = 'top', text, children }) => {
    const theme = useTheme();
    return (_jsx(MUITooltip, { arrow: true, components: {
            Tooltip: Paper,
        }, componentsProps: {
            arrow: {
                sx: {
                    color: theme.palette.background.paper,
                    ':before': {
                        boxShadow: theme.shadows[1],
                    },
                },
            },
            tooltip: {
                sx: {
                    maxWidth: 265,
                    padding: 1.5,
                    boxShadow: theme.shadows[3],
                },
            },
        }, placement: placement, title: _jsxs(Box, { display: 'flex', flexDirection: 'column', children: [React.isValidElement(title) ? title : title && _jsx(Subheader3, { mb: 1, children: title }), React.isValidElement(text) ? (text) : (_jsx(Caption, { sx: { whiteSpace: 'pre-line' }, children: React.isValidElement(text) ? text : `${text}` }))] }), children: children }));
};
export default Tooltip;
